// Search Popup Functionality
const searchPopupTriggers = document.querySelectorAll( '[data-search-popup-trigger]' );
const searchPopup = document.getElementById( 'search-popup' );
const searchBarContainer = searchPopup?.closest( '.search-bar' );
const searchPopupOverlay = searchBarContainer?.querySelector( '.search-popup__overlay' );
const searchPopupTabs = searchPopup?.querySelectorAll( '.search-popup__tab' );
const predictiveSearchElement = searchPopup?.querySelector( '#predictive-search-popup' );
const searchPopupForm = document.querySelector( '[data-search-popup-form]' );
const searchPopupInput = searchPopupForm?.querySelector( '[data-search-popup-input]' );
let activeSearchCategory = searchPopupTabs?.[ 0 ]?.dataset.category || null;
const popupTriggers = searchPopupTriggers.length > 0 ? Array.from( searchPopupTriggers ) : ( searchPopupInput ? [ searchPopupInput ] : [] );

if ( popupTriggers.length > 0 && searchPopup ) {
  const syncActivePanels = () => {
    if ( !searchPopup ) {
      return;
    }

    const panels = searchPopup.querySelectorAll( '.search-popup__tabpanel' );
    panels.forEach( panel => {
      panel.classList.toggle( 'active', panel.dataset.panel === activeSearchCategory );
    } );

    searchPopupTabs?.forEach( tab => {
      tab.classList.toggle( 'active', tab.dataset.category === activeSearchCategory );
    } );
  };

  const setActiveSearchCategory = ( category ) => {
    if ( !category ) {
      return;
    }

    activeSearchCategory = category;
    syncActivePanels();
    // Update hidden tag filter
    document.querySelectorAll( '.search-tag-filter' ).forEach( el => el.value = category );
  };

  const openSearchPopup = () => {
    searchPopup.classList.remove( 'hidden' );
    searchPopupForm?.classList.add( 'search-wrapper--popup-open' );
    searchBarContainer?.classList.add( 'search-bar--popup-open' );
    if ( !activeSearchCategory && searchPopupTabs?.[ 0 ] ) {
      activeSearchCategory = searchPopupTabs[ 0 ].dataset.category;
    }
    syncActivePanels();
    if ( searchPopupInput && document.activeElement !== searchPopupInput ) {
      searchPopupInput.focus();
    }
  };

  const closeSearchPopup = () => {
    searchPopup.classList.add( 'hidden' );
    searchPopupForm?.classList.remove( 'search-wrapper--popup-open' );
    searchBarContainer?.classList.remove( 'search-bar--popup-open' );
  };

  popupTriggers.forEach( trigger => {
    if ( trigger.tagName === 'INPUT' ) {
      trigger.addEventListener( 'focus', () => {
        openSearchPopup();
      } );
    }

    trigger.addEventListener( 'click', ( event ) => {
      if ( trigger.tagName !== 'INPUT' ) {
        event.preventDefault();
      }

      openSearchPopup();
    } );
  } );

  if ( searchPopupForm ) {
    searchPopupForm.addEventListener( 'focusin', () => {
      openSearchPopup();
    } );
  }

  if ( searchPopupTabs ) {
    searchPopupTabs.forEach( tab => {
      tab.addEventListener( 'click', () => {
        setActiveSearchCategory( tab.dataset.category );
      } );
    } );
  }

  if ( predictiveSearchElement ) {
    const predictiveObserver = new MutationObserver( () => {
      syncActivePanels();
    } );

    predictiveObserver.observe( predictiveSearchElement, { childList: true, subtree: true } );
  }

  if ( searchPopupForm && searchPopupInput ) {
    searchPopupForm.addEventListener( 'submit', () => {
      if ( !activeSearchCategory ) {
        return;
      }

      const sanitizedQuery = ( searchPopupInput.value || '' ).replace( /\s+tag:[^\s]+/gi, '' ).trim();
      const tagQuery = `tag:${ activeSearchCategory }`;
      searchPopupInput.value = `${ sanitizedQuery } ${ tagQuery }`.trim();
    } );
  }

  searchPopupOverlay?.addEventListener( 'click', closeSearchPopup );

  document.addEventListener( 'keydown', ( event ) => {
    if ( event.key === 'Escape' && !searchPopup.classList.contains( 'hidden' ) ) {
      closeSearchPopup();
    }
  } );
}

// Make outer search inputs readonly on mobile to prevent submission
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth <= 768) {
      const inputs = document.querySelectorAll('[data-search-popup-input]');
      if (inputs && inputs.length > 0) {
        inputs.forEach(function(input) {
          if (!input.closest('.search-popup__mobile-search')) {
            input.readOnly = true;
          }
        });
      }
    }
  });
})();
